import React, { Component } from "react";
import Diagram from "./Diagram/Diagram";
import "./Statistics.css";

class Statistics extends Component {
    constructor(props) {
        super(props);
        this.get_data = this.get_data.bind(this);
    }

    get_data() {
        let { connection, router, toast } = this.props;

        connection
            .get_filtered_data("items")
            .then((res) => {
                let { items } = res.data;
                connection
                    .getAllCategories()
                    .then((res) => {
                        let categories = res.data;
                        let no_cat = [];
                        categories.forEach((category) => {
                            category.items = items.filter((item) => {
                                if (
                                    (!item.categories ||
                                        item.categories.length == 0) &&
                                    !no_cat.find((i) => {
                                        return i.id == item.id;
                                    })
                                ) {
                                    no_cat.push(item);
                                } else
                                    return item.categories.includes(
                                        category.name
                                    );
                            });
                        });
                        categories.push({ name: "دیگر", items: no_cat });
                        this.setState({ categories });
                    })
                    .catch((err) => {
                        toast(
                            "دریافت دسته بندی ها",
                            " خطا در دریافت دسته بندی ها" + err,
                            " danger"
                        );
                    });
            })
            .catch((err) => {
                toast(
                    "دریافت دسته بندی ها",
                    " خطا در دریافت دسته بندی ها" + err,
                    " danger"
                );
            });
    }

    componentDidMount() {
        this.get_data();
    }
    state = {
        categories: null,
        selected_category: null,
        mode: "sold_count",
    };
    render() {
        let { categories, selected_category, mode } = this.state;
        return (
            <div className="StatisticsComponent">
                <button
                    className="mode btn info"
                    onClick={(ev) =>
                        this.setState({
                            mode:
                                mode == "sold_count" ? "visited" : "sold_count",
                        })
                    }
                >
                    {`نمایش آمار `}
                    <div className="text danger">
                        {mode == "sold_count" ? "بازدید" : "فروش"}
                    </div>
                </button>
                <div className="holder">
                    {categories && (
                        <Diagram
                            selected_category={selected_category}
                            categories={categories}
                            mode={mode}
                            set_cat={(sc) =>
                                this.setState({ selected_category: sc })
                            }
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default Statistics;
